import { NavLink } from 'react-router-dom';
import { isInternalURL } from '@plone/volto/helpers/Url/Url';
import { toBackendLang } from '@plone/volto/helpers/Utils/Utils';
import config from '@plone/volto/registry';

import { useNavigation } from './NavigationContext';
import NavigationDropdown from './NavigationDropdown';
import type { NavigationItem } from './types';

interface NavItemProps {
  item: NavigationItem;
}

const NavItem = ({ item }: NavItemProps) => {
  const { settings } = config;
  const { lang, closeAll } = useNavigation();

  const hasChildren = item.items.length > 0;

  if (isInternalURL(item.url) || item.url === '') {
    return (
      <div className="nav-item-wrap">
        <NavLink
          to={item.url === '' ? '/' : item.url}
          className="item"
          activeClassName="active"
          exact={
            settings.isMultilingual
              ? item.url === `/${toBackendLang(lang)}`
              : item.url === ''
          }
          onClick={closeAll}
        >
          {item.title}
        </NavLink>
        {hasChildren && <NavigationDropdown item={item} />}
      </div>
    );
  }

  return (
    <a
      href={item.url}
      className="item"
      rel="noopener noreferrer"
      target={settings.openExternalLinkInNewTab ? '_blank' : '_self'}
    >
      {item.title}
    </a>
  );
};

export default NavItem;